// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartitionEntity } from './PartitionEntity';
import {
  PartitionEntityFromJSON,
  PartitionEntityFromJSONTyped,
  PartitionEntityToJSON,
  PartitionEntityToJSONTyped,
} from './PartitionEntity';

/**
 *
 * @export
 * @interface PartitionList
 */
export interface PartitionList {
  /**
   *
   * @type {Array<PartitionEntity>}
   * @memberof PartitionList
   */
  items?: Array<PartitionEntity>;
}

/**
 * Check if a given object implements the PartitionList interface.
 */
export function instanceOfPartitionList(value: object): value is PartitionList {
  return true;
}

export function PartitionListFromJSON(json: any): PartitionList {
  return PartitionListFromJSONTyped(json, false);
}

export function PartitionListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PartitionList {
  if (json == null) {
    return json;
  }
  return {
    items:
      json['items'] == null
        ? undefined
        : (json['items'] as Array<any>).map(PartitionEntityFromJSON),
  };
}

export function PartitionListToJSON(json: any): PartitionList {
  return PartitionListToJSONTyped(json, false);
}

export function PartitionListToJSONTyped(
  value?: PartitionList | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    items:
      value['items'] == null
        ? undefined
        : (value['items'] as Array<any>).map(PartitionEntityToJSON),
  };
}
